import { useEffect, useState } from "react";
import { getBaseAccessToken, getUserAuthUrl, loadTokens, saveTokensAndTime } from "../../controllers/SpotifyAccountController";
import { loadAccessToken } from "../../utils/localStorageUtils";
import { REDIRECT_URI } from "../../utils/constants/connectionConstants";
import { useDispatch, useSelector } from "react-redux";
import { isAuth } from "../../reducers/authState";
import { setAuth, setAuthenticating, setPremiumAccount } from "../../actions/authActions";
import { startWorkers, stopWorkers } from "../../actions/workersActions";
import { checkPremiumAccount } from "../../controllers/SpotifyApiController";
import { timeout } from "../../utils/utils";

export const useLogIn = () => {
    const auth = useSelector(isAuth);
    const [authUrl, setAuthUrl] = useState(undefined);

    const dispatch = useDispatch();

    useEffect(() => {
        const checkPremiumAndStart = (redirect) => {
            checkPremiumAccount()
            .then((premiumAccount) => {
                dispatch(setPremiumAccount(premiumAccount));
                dispatch(setAuth(true));

                // We wait half a second to avoid too many changes on screen in so little time
                timeout(500)
                .then(() => {
                    dispatch(setAuthenticating(false));

                    if(premiumAccount) {
                        dispatch(startWorkers());
                    }
                    else {
                        dispatch(stopWorkers());
                    }
                });
                
                if(redirect) {
                    window.history.replaceState({}, '', REDIRECT_URI);
                }
            })
            .catch((error) => {
                dispatch(setPremiumAccount(false));
                dispatch(setAuth(true));
                dispatch(setAuthenticating(false));

                dispatch(stopWorkers());

                console.error("Error checking if the Spotify account is premium", error);

                if(redirect) {
                    window.history.replaceState({}, '', REDIRECT_URI);
                }
            })
        }

        if(auth)
        {
            return;
        }

        const { accessToken, refreshToken } = loadTokens();

        if(accessToken && refreshToken)
        {
            dispatch(setAuthenticating(true));
            checkPremiumAndStart();
            return;
        }

        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const error = urlParams.get('error');

        if(code || error)
        {
            if(error)
            {
                console.error('Error getting auth token: ', error);
                return;
            }

            if(code)
            {
                dispatch(setAuthenticating(true));
                getBaseAccessToken(code)
                .then((response) => {
                    saveTokensAndTime(response);
                    checkPremiumAndStart(true);
                })
                .catch((error) => {
                    console.error('Error getting auth token: ', error);
                });
            }
        }
        else
        {
            getUserAuthUrl()
                .then((result) => setAuthUrl(result));
        }
    }, [auth, dispatch])

    const accessToken = loadAccessToken();

    if(accessToken)
    {
        return { accessToken };
    }

    return { authUrl };

}